import PartnerImg from 'assets/images/subscriptions/friend.png';
import OnProbationImg from 'assets/images/subscriptions/malepose_1.png';
import FriendImg from 'assets/images/subscriptions/partner.png';

export const PRODUCTS_IMAGES = {
  ON_PROBATION: OnProbationImg,
  FRIEND: FriendImg,
  PARTNER: PartnerImg,
};
